'use strict';

var isTryAtShowroomRequestActive = false;

/**
 * Override customDropDown.js behavior for try-at-showroom time slots.
 * Prevents the dropdown from closing when clicking inside .try-at-showroom-form .custom-option-values
 * Dropdown only closes when clicking on a valid (non-strick-out) time slot
 */
document.addEventListener('click', function (e) {
    // allow click if it is a VALID slot
    if (e.target.closest('.try-at-showroom-form .time-slot-value:not(.strick-out)')) {
        return; // allow closing logic
    }

    // block everything else inside dropdown
    if (e.target.closest('.try-at-showroom-form .custom-option-values')) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}, true);

/**
 * Loads available showroom slots for a selected store.
 *
 * @function loadSlots
 * @param {string} storeId - The unique identifier of the selected store.
 * @description
 * Sends an AJAX request to the TryAtShowRoom to retrieve available
 * time slots for the given store. Updates the slot selection section in the
 * modal with the returned HTML content and resets the selected slot text.
 */
function loadSlots(storeId) { // Reusable function to load slots
    $.ajax({
        url: 'TryAtShowRoom-GetSlots',
        method: 'GET',
        data: { storeID: storeId },
        success: function (html) {
            $('#tryAtSlot').html(html);
            $('.tas-selected-value').each(function () {
                var $this = $(this);
                var altText = $this.data('alttext');
                $this.text(altText || '');
            });
        }
    });
}

/**
 * Resets the time slot selection to its default state.
 * Updates the text of the selected time slot element to show the alternative text
 * (either from data-alttext attribute or defaults to 'Choose...').
 *
 * @function resetTimeSlot
 * @returns {void}
 */
function resetTimeSlot() {
    var $sel = $('.tas-selected-value');
    var altText = $sel.attr('data-alttext') || $sel.data('alttext') || 'Choose...';
    $sel.text(altText);
    $sel.attr('data-slot', '');
    $('#selectedPickupSlot').val('');
}

/**
 * Sends Try At Showroom data to the server and
 * updates the DOM with available time slots.
 *
 * @function updateTimeSlots
 * @returns {void}
 */
function updateTimeSlots() {
    var selectedValue = $('input[name="storeSelect"]:checked').val();
    var customerPhone = $('.customerPhone').val();
    var customerEmail = $('.customerEmail').val();
    var selectedDate = $('#tryAtDate').val();
    var tasSelectedValue = $('.tas-selected-value').attr('data-slot');
    var url = $('#tryAtShowRoomTimeDropdown').data('url');

    var tryatshowroomData = {
        storeID: selectedValue,
        customerPhone: customerPhone,
        customerEmail: customerEmail,
        selectedDate: selectedDate,
        tasSelectedValue: tasSelectedValue || ''
    };

    $.ajax({
        url: url,
        method: 'POST',
        data: tryatshowroomData,
        success: function (data) {
            if (data.success === false) {
                $('#tryAtShowroomForm .pickup-slot-scroll').addClass('d-none');
            } else {
                $('#tryAtShowroomForm .pickup-slot-scroll').removeClass('d-none');
                $('#tryAtSlot').html(data);
            }
        }
    });
}

$(document).on('click', '#openTryAtShowroomBtn', function () {
    var isLoggedin = $('#isAuthenticated').val();
    if (isLoggedin === 'true') {
        if (isTryAtShowroomRequestActive) {
            return;
        }

        var $tryAtShowroomModal = $('#tryAtShowroomModal');
        if ($tryAtShowroomModal.length && $tryAtShowroomModal.hasClass('show')) {
            return;
        }

        isTryAtShowroomRequestActive = true;

        var pid = $(this).data('pid');
        var url = $(this).data('url');
        $.ajax({
            url: url,
            data: { pid: pid },
            type: 'get',
            success: function (response) {
                // Inject the new modal content
                $('#tryAtShowroomModalContainer').html(response);

                // Datepicker initialization
                var $dateInput = $('#tryAtShowroomModalContainer').find('.try-at-showroom-form-date-input');
                if ($dateInput.length) {
                    // Parse holiday data from hidden input in product page (not modal)
                    var $holidayInput = $('#tryAtShowroomHolidaysData');
                    var holidaysJson = $holidayInput.val();
                    var allHolidayData = {};

                    allHolidayData = JSON.parse(holidaysJson) || null;

                    /**
                     * Get holidays for currently selected store
                     * @returns {Object} Object with holiday dates as keys
                     */
                    var getHolidaysForSelectedStore = function () {
                        var holidays = [];

                        // Always add common holidays
                        if (allHolidayData && allHolidayData.commonHolidays && Array.isArray(allHolidayData.commonHolidays)) {
                            holidays = holidays.concat(allHolidayData.commonHolidays);
                        }

                        // Get selected store ID
                        var selectedStoreId = $('input[name="storeSelect"]:checked').val();

                        if (selectedStoreId && allHolidayData.showroomHolidays && Array.isArray(allHolidayData.showroomHolidays)) {
                            // Find holidays for the selected store
                            var selectedStoreHolidays = allHolidayData.showroomHolidays.find(function (store) {
                                return store.storeId === selectedStoreId;
                            });

                            if (selectedStoreHolidays && selectedStoreHolidays.holidays && Array.isArray(selectedStoreHolidays.holidays)) {
                                holidays = holidays.concat(selectedStoreHolidays.holidays);
                            }
                        }

                        // Convert to Set for faster lookup
                        var holidaysSet = {};
                        holidays.forEach(function (date) {
                            holidaysSet[date] = true;
                        });

                        return holidaysSet;
                    };

                    $.fn.datepicker.dates.en.daysMin = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

                    // Destroy any existing datepicker instance
                    if ($dateInput.data('datepicker')) {
                        $dateInput.datepicker('destroy');
                    }

                    // Initialize datepicker with beforeShowDay callback
                    $dateInput.datepicker({
                        format: 'dd/mm/yyyy',
                        language: 'en',
                        autoclose: true,
                        todayHighlight: false,
                        startDate: '+0d',
                        weekStart: 1,
                        maxViewMode: 2,
                        beforeShowDay: function (date) {
                            // Get current holidays based on selected store
                            var holidaysSet = getHolidaysForSelectedStore();

                            // Format date to DD/MM/YYYY to match holiday format
                            var day = ('0' + date.getDate()).slice(-2);
                            var month = ('0' + (date.getMonth() + 1)).slice(-2);
                            var year = date.getFullYear();
                            var dateString = day + '/' + month + '/' + year;

                            // Check if date is in holidays set
                            var isHoliday = holidaysSet[dateString] === true;

                            // Return [enabled, className, tooltip]
                            return !isHoliday;
                        }
                    });

                    // Set today's date and attach event handlers
                    $dateInput.datepicker('setDate', new Date());

                    $dateInput.on('show', function (e) {
                        e.stopPropagation();
                    });

                    $dateInput.on('click', function () {
                        $('.table-condensed .prev, .table-condensed .next').text('');
                    });

                    // Listen for store selection change and refresh datepicker
                    $(document).on('change', 'input[name="storeSelect"]', function () {
                        // Update datepicker to reflect new store's holidays
                        $dateInput.datepicker('update');
                    });
                }

                // Load slots if store selected
                var checkedInput = $('input[name="storeSelect"]:checked');
                var slotStatus = $('.tas-selected-value').data('slot');
                if (checkedInput.length) {
                    if (slotStatus === 'default') loadSlots(checkedInput.val());
                    else {
                        $.ajax({
                            url: 'TryAtShowRoom-GetSlots',
                            method: 'GET',
                            data: { storeID: checkedInput.val() },
                            success: function (html) { $('#tryAtSlot').html(html); }
                        });
                    }
                }

                // Show the modal
                $('#tryAtShowroomModal').modal('show');
            },
            complete: function () {
                isTryAtShowroomRequestActive = false;
            }
        });
    } else {
        // open Login Modal
        $('#ckc-login-modal').modal('show');

        var $wrap = $('.ckc-login-countrycode-drop-down');
        $wrap.find('.custom-option-value.active, .custom-option-value.selected').removeClass('active selected');
        var $defaultOption = $wrap.find('.custom-option-value[data-id="+91"]');
        $defaultOption.addClass('active selected');
        $wrap.find('.custom-drop-down-login .selected-value').text($defaultOption.data('id')).addClass('active');
        $('#loginInput').addClass('w-100 border-left border-1').removeClass('country-code-field');
        $('.country-select-wrap').addClass('d-none');
        $('#loginInput').addClass('w-100');
        $('.login-modal-missing-error, .login-modal-customer-exists-error, .login-modal-result, .login-mobile-country-miss-match-error, #register-form-modal, .ckc-password-register-content, .ckc-register-form-content').addClass('d-none');
    }
});

// When the user clicks the terms and conditions checkbox
$(document).on('click', '.terms-conditions-checkbox', function () {
    var checkbox = $('#tryatshowroom-termsandconditions');
    if (checkbox.prop('checked')) {
        checkbox.prop('checked', false);
    } else {
        $('#tryAtShowroomModal').modal('hide');
        $('#tryatshowroom-terms-modal').modal('show');
    }
});

// When the user clicks the "Agree & Continue" button in the terms modal
$(document).on('click', '.tryatshowroom-agree-btn', function () {
    $('#tryatshowroom-terms-modal').modal('hide');
    $('#tryAtShowroomModal').modal('show');
    $('#tryatshowroom-termsandconditions').prop('checked', true);
    $('.invalid-tas-term').addClass('d-none').removeClass('d-block');
});

$(document).on('click', '#tryAtShowRoomTimeDropdown', function () {
    if (!$('#tryAtShowRoomTimeDropdown').hasClass('opened')) {
        var selectedValue = $('input[name="storeSelect"]:checked').val();
        var customerPhone = $('.customerPhone').val();
        var customerEmail = $('.customerEmail').val();
        var selectedDate = $('#tryAtDate').val();
        var tasSelectedValue = $('.tas-selected-value').attr('data-slot');
        var url = $(this).data('url');
        if (!selectedValue) {
            $('#tryAtShowroomForm .pickup-slot-scroll').addClass('d-none');
            $('#tryAtShowRoomTimeDropdown.custom-drop-down').addClass('is-invalid');
            $('.invalid-tas-tryAtSlot').removeClass('d-block').addClass('d-none');
            $('.not-available-tas-tryAtSlot').removeClass('d-block').addClass('d-none');
            $('.missing-tas-select-store').removeClass('d-none').addClass('d-block');
            return;
        }
        var tryatshowroomData = {
            storeID: selectedValue,
            customerPhone: customerPhone,
            customerEmail: customerEmail,
            selectedDate: selectedDate,
            tasSelectedValue: tasSelectedValue || ''
        };
        $.spinner().start();
        $.ajax({
            url: url,
            method: 'POST',
            data: tryatshowroomData,
            success: function (data) { // eslint-disable-line no-unused-vars
                $.spinner().stop();
                if (data.success === false) {
                    $('#tryAtShowroomForm .pickup-slot-scroll').addClass('d-none');
                    $('#tryAtShowRoomTimeDropdown.custom-drop-down').addClass('is-invalid');
                    $('.invalid-tas-tryAtSlot').removeClass('d-block').addClass('d-none');
                    $('.missing-tas-select-store').removeClass('d-block').addClass('d-none');
                    $('.not-available-tas-tryAtSlot').removeClass('d-none').addClass('d-block');
                } else {
                    $('#tryAtShowroomForm .pickup-slot-scroll').removeClass('d-none');
                    $('#tryAtSlot').html(data);
                    $('#tryAtShowroomForm .pickup-slot-scroll').scrollTop(0);
                }
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
});

// When the terms modal is hidden (closed)
$(document).on('hidden.bs.modal', '#tryatshowroom-terms-modal', function (e) {
    if (e.target.id === 'tryatshowroom-terms-modal') {
        $('#tryatshowroom-terms-modal').modal('hide');
        $('#tryAtShowroomModal').modal('show');
    }
});

$(document).on('change', '#tryAtShowroomModal input[name="storeSelect"]', function () { // Update slots when store is changed
    var storeId = $(this).val();
    loadSlots(storeId);
    resetTimeSlot();

    // Always show current date on edit
    var $tryAtDate = $('#tryAtDate');
    var today = new Date();
    if ($tryAtDate.length) {
        if ($tryAtDate.data('datepicker')) {
            $tryAtDate.datepicker('setDate', today);
        } else {
            var day = ('0' + today.getDate()).slice(-2);
            var month = ('0' + (today.getMonth() + 1)).slice(-2);
            var year = today.getFullYear();
            $tryAtDate.val(day + '/' + month + '/' + year);
        }
        $tryAtDate.trigger('change');
    }

    // Show placeholder/alt text for the slot label
    var $tasSelectedValue = $('.tas-selected-value');
    if ($tasSelectedValue.length) {
        var altText = $tasSelectedValue.attr('data-alttext') || $tasSelectedValue.data('alttext');
        $tasSelectedValue.text(altText || '');
        $tasSelectedValue.attr('data-slot', '');
        $('#selectedPickupSlot').val('');
    }
});

$(document).on('click', '.cancel-selection', function () { // cancel selection and reset form
    // Reset modal fields
    $('input[name="storeSelect"]').prop('checked', false);
    $('#tryAtDate, #pickupSlot, #selectedPickupSlot').val('');

    // Cache the element and get its alt text
    resetTimeSlot();

    // Close modal
    $('#tryAtShowroomModal').modal('hide');
});

$(document).on('click', '.book-selection', function () { // Save selection (store, date, slot)
    var storeID = $('input[name="storeSelect"]:checked').val();
    var date = $('#tryAtDate').val();
    var slot = $('#selectedPickupSlot').val();
    var url = $('.book-selection').data('url');
    var isTermsChecked = $('#tryatshowroom-termsandconditions').prop('checked');

    var scrollContainer = $('#tryAtShowroomForm');
    let scrollTarget = null;

    var hasError = false;

    if (!date) {
        $('.invalid-feedback.invalid-tas-tryAtDate').text($('#tryAtDate').data('dismiss'));
        $('#tryAtShowroomForm .date-picker').addClass('is-invalid');
        scrollTarget = $('.invalid-tas-tryAtDate');
        hasError = true;
    }

    if (!slot) {
        $('.not-available-tas-tryAtSlot, .missing-tas-select-store').removeClass('d-block').addClass('d-none');
        $('.invalid-tas-tryAtSlot').removeClass('d-none').addClass('d-block');
        $('#tryAtShowRoomTimeDropdown.custom-drop-down').addClass('is-invalid');
        scrollTarget = $('.invalid-tas-tryAtSlot');
        hasError = true;
    }

    if (!isTermsChecked) {
        $('.invalid-tas-term').removeClass('d-none').addClass('d-block');
        scrollTarget = $('.invalid-tas-term');
        hasError = true;
    }

    if (!hasError) {
        $.spinner().start();
        $.ajax({
            url: url,
            method: 'POST',
            data: {
                storeSelect: storeID,
                tryAtDate: date,
                tryAtSlot: slot.replace('-', ' to ')
            },
            success: function (html) {
                $('#tryAtShowroomModal').modal('hide');
                $.spinner().stop();
                $('#appointmentDetailsContainer').html(html);
                var $injectedContent = $('#appointmentDetailsContainer');
                var $successModal = $injectedContent.find('#appointment-details-modal');
                var $errorModal = $injectedContent.find('#allreadyhaveresponsetryatshowroom');

                if ($successModal.length > 0) {
                    $successModal.modal('show');
                } else if ($errorModal.length > 0) {
                    $errorModal.modal('show');
                    setTimeout(function () {
                        $errorModal.modal('hide');
                    }, 3000);
                }
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }

    // Scroll to first error if any
    if (scrollTarget && scrollTarget.length) {
        scrollContainer.animate({
            scrollTop: scrollContainer.scrollTop() + scrollTarget.position().top - (-390)
        }, 500);
    }
});

/**
 * EDIT button → re-open previous Try at Showroom modal with data prefilled
 */
$(document).on('click', '.tas-edit-btn', function () {
    var store = $('.tas-modal-location')
        .text()
        .trim()
        .split(':')
        .pop()
        .trim();
    var date = $('.tas-modal-date')
        .text()
        .trim()
        .split(':')
        .pop()
        .trim();
    var slot = $('.tas-selected-value').data('slot').replace(' to ', '-');

    // hide current modal
    $('#appointment-details-modal, #bopisModal').modal('hide');

    // open previous showroom modal
    $('#tryAtShowroomModal').modal('show');

    // prefill values
    if (store) {
        $(`input[name="storeSelect"][value="${store}"]`).prop('checked', true);
    }
    if (date) {
        $('#tryAtDate').val(date);
    }
    if (slot) {
        $('#selectedPickupSlot').val(slot);
        $('.tas-selected-value').text(slot);
        $('.tas-selected-value').attr('data-slot', slot);
    }
});

$(document).on('click', '.tas-confirm-btn', function () {
    var storeLocation = $(this).data('location');
    var selectedDate = $(this).data('date');
    var selectedSlot = $(this).data('slot');
    var selectedStoreID = $(this).data('storeid');
    var storeImage = $(this).data('imgurl');
    var url = $(this).data('url');
    var pid = $('.productId').val();
    $.spinner().start();
    $.ajax({
        url: url,
        method: 'POST',
        data: {
            location: storeLocation,
            date: selectedDate,
            slot: selectedSlot.replace(' to ', '-'),
            imgUrl: storeImage,
            productID: pid,
            storeID: selectedStoreID
        },
        success: function (response) {
            if (response.success) {
                // Close the previous modal first
                $('#appointment-details-modal').modal('hide');
                $.spinner().stop();

                var storeDetails = response.selectedStore;

                var $appointmentModal = $('#appointment-confirmation-modal');

                // Populate data into confirmation modal
                $appointmentModal.find('.showroom-location-label').text(storeDetails.location);
                $appointmentModal.find('.showroom-date-label').text(storeDetails.date);
                $appointmentModal.find('.showroom-slot-label').text(storeDetails.slot.replace('-', ' to '));
                $appointmentModal.find('.tas-modal-image').attr('src', storeDetails.imgUrl);

                // Now show confirmation modal
                $appointmentModal.modal('show');
            } else {
                $('#appointment-details-modal').modal('hide');
                $.spinner().stop();
                var $errorModal = $('#allreadyhaveresponsetryatshowroom');
                if (response.message) {
                    $errorModal.find('.message-text').text(response.message);
                }
                $errorModal.modal('show');
                setTimeout(function () {
                    $errorModal.modal('hide');
                }, 3000);
            }
        },
        error: function () {
            $.spinner().stop();
        }
    });
});

$(document).on('change', '#tryAtDate', function () { // Extra: hide error when user selects date
    if ($(this).val().trim() === '') {
        $('#tryAtShowroomForm .date-picker').addClass('is-invalid');
        $('.invalid-feedback.invalid-tas-tryAtDate').text($('#tryAtDate').data('dismiss'));
        return;
    }

    if ($(this).val().trim()) {
        $('#tryAtShowroomForm .date-picker').removeClass('is-invalid');
        $('#tryAtShowRoomTimeDropdown.custom-drop-down').removeClass('is-invalid');
        $('.invalid-feedback.invalid-tas-tryAtDate').text('');
        $('.invalid-tas-tryAtSlot, .not-available-tas-tryAtSlot, .missing-tas-select-store').removeClass('d-block').addClass('d-none');
        resetTimeSlot();

        // Refresh the DOM time slots based on the new date selection
        updateTimeSlots();
    }
});

$(document).on('click', '.try-at-showroom-form .time-slot-value:not(.strick-out)', function (e) {
    e.stopPropagation(); // stop document click

    var selectedSlot = $(this).data('id');
    $('#selectedPickupSlot').val(selectedSlot);

    $('.tas-selected-value').attr('data-slot', selectedSlot);

    var $dropdown = $(this).closest('.custom-option-values');
    $dropdown.hide();
    $dropdown.prev('.custom-drop-down')
        .removeClass('opened')
        .find('.down-arrow')
        .removeClass('rotate-arrow');

    $('.invalid-tas-tryAtSlot').addClass('d-none').removeClass('d-block');
    $('#tryAtShowRoomTimeDropdown').removeClass('is-invalid');
});
